import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { notification } from "antd";

// — List all members
export const fetchStaffGroupMembers = createAsyncThunk(
  "staffGroupMembers/fetchAll",
  async () => {
    const { data } = await api.get(API_ENDPOINTS.security.staffGroupMembers.getAll);
    return data;
  }
);

// — Get by ID
export const fetchStaffGroupMemberById = createAsyncThunk(
  "staffGroupMembers/fetchById",
  async (id) => {
    const { data } = await api.get(API_ENDPOINTS.security.staffGroupMembers.getById + id);
    return data;
  }
);

// — Create
export const createStaffGroupMember = createAsyncThunk(
  "staffGroupMembers/create",
  async (payload,{rejectWithValue}) => {
    try {
    const { data } = await api.post(API_ENDPOINTS.security.staffGroupMembers.create, payload);
    if(data?.statusCode==500){
      let msg=""
      if(data?.message?.includes("staff member already exist in the group")){
        msg="Staff member already exist in the group"
      }else{
        msg="Error while adding staff"
      }
      throw new Error(msg)
    }
    return data;
    } catch (error) {
      notification.error({
        message: "Error",
        description: error?.message || "An unexpected error occurred.",
        placement: "topRight",
      });
      return rejectWithValue( "An error occurred");
    }

  }
);

// — Update
export const updateStaffGroupMember = createAsyncThunk(
  "staffGroupMembers/update",
  async (payload) => {
    const { data } = await api.post(API_ENDPOINTS.security.staffGroupMembers.update, payload);
    return data;
  }
);

// — Delete
export const deleteStaffGroupMember = createAsyncThunk(
  "staffGroupMembers/delete",
  async (id) => {
    await api.delete(API_ENDPOINTS.security.staffGroupMembers.delete + id);
    return id;
  }
);
